import { type ComponentProps } from 'react';

import { Communication, General, Media, Users } from '../StrokeIcons';

export type StepIconSvgType =
  | 'message'
  | 'connect'
  | 'inmail'
  | 'visit'
  | 'follow'
  | 'email'
  | 'reminder'
  | 'call'
  | 'delay'
  | 'likeRecentPosts'
  | 'wait_for_connect'
  | 'voice_note'
  | 'sift';

export type StepIconSvgProps = ComponentProps<'svg'> & {
  iconType: StepIconSvgType;
};
export default function StepIconSvg({ iconType, ...props }: StepIconSvgProps) {
  switch (iconType) {
    case 'email':
      return <Communication.Mail02 {...props} />;
    case 'call':
      return <Communication.PhoneOutgoing01 {...props} />;
    case 'connect':
      return <Users.UserPlus01 {...props} />;
    case 'inmail':
      return <Communication.InMail04 {...props} />;
    case 'follow':
      return <General.Plus {...props} />;
    case 'visit':
      return <General.Eye {...props} />;
    case 'message':
      return <General.StepMessage {...props} />;
    case 'reminder':
      return <General.CheckSquareBroken {...props} />;
    case 'likeRecentPosts':
      return <General.Heart {...props} />;
    case 'voice_note':
      return <Media.Recording01 {...props} />;
    case 'sift':
      return <General.FilterLines {...props} />;
    default:
      return null;
  }
}
